import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/design-system/index.css";
import "./AppV2.css";
import { ThemeProvider } from "./components/ThemeProvider";
import { CookieConsentV2 } from "./components/v2/CookieConsentV2";
import { Toaster } from "./components/ui/toaster";
import { LayoutV2 } from "./components/v2/layout/LayoutV2";

const HomePageV2 = lazy(() =>
  import("./pages/v2/HomePageV2").then((m) => ({ default: m.HomePageV2 }))
);
const SolutionPage = lazy(() =>
  import("./pages/v2/SolutionPage").then((m) => ({ default: m.SolutionPage }))
);
const WorkIndexPage = lazy(() =>
  import("./pages/v2/WorkIndexPage").then((m) => ({ default: m.WorkIndexPage }))
);
const CaseStudyPage = lazy(() =>
  import("./pages/v2/CaseStudyPage").then((m) => ({ default: m.CaseStudyPage }))
);
const AboutPage = lazy(() =>
  import("./pages/v2/AboutPage").then((m) => ({ default: m.AboutPage }))
);
const ContactPage = lazy(() =>
  import("./pages/v2/ContactPage").then((m) => ({ default: m.ContactPage }))
);
const PrivacyPage = lazy(() =>
  import("./pages/v2/PrivacyPage").then((m) => ({ default: m.PrivacyPage }))
);
const TermsPage = lazy(() =>
  import("./pages/v2/TermsPage").then((m) => ({ default: m.TermsPage }))
);
const CookiePolicyPage = lazy(() =>
  import("./pages/v2/CookiePolicyPage").then((m) => ({
    default: m.CookiePolicyPage,
  }))
);
const NotFoundPage = lazy(() =>
  import("./pages/v2/NotFoundPage").then((m) => ({ default: m.NotFoundPage }))
);

function PageLoader() {
  return (
    <div
      className="v2-app min-h-screen flex items-center justify-center bg-v2-background"
      role="status"
      aria-label="Loading page"
    >
      <div
        className="w-8 h-8 border-2 border-brand border-t-transparent rounded-full animate-spin"
        aria-hidden="true"
      />
      <span className="sr-only">Loading page content</span>
    </div>
  );
}

function AppV2() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<LayoutV2 />}>
              <Route index element={<HomePageV2 />} />
              <Route path="solutions/:slug" element={<SolutionPage />} />
              <Route path="work" element={<WorkIndexPage />} />
              <Route path="work/:slug" element={<CaseStudyPage />} />
              <Route path="company/about" element={<AboutPage />} />
              <Route path="company/contact" element={<ContactPage />} />
              <Route path="legal/privacy" element={<PrivacyPage />} />
              <Route path="legal/terms" element={<TermsPage />} />
              <Route path="legal/cookies" element={<CookiePolicyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </Suspense>
        <Toaster />
        <CookieConsentV2 />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default AppV2;
